import "./OpenSketchfabButton.css";
import { stateIframeWindow } from "../store";
import { useSnapshot } from "valtio";
import { getSketchfabUrl } from "../Utils/sketchfabLinks";

// "Open Sketchfab"-Button neben dem Close-Button im Model-Viewer.
// Öffnet die öffentliche Sketchfab-Seite des Artefakts in einem NEUEN Tab
// (früher lief das auf Desktop in einem iframe — nicht mehr gewünscht).
export default function OpenSketchfabButton() {
  const snap = useSnapshot(stateIframeWindow);

  // Link IMMER über die AnnotationId aus den Labels auflösen (verlässliche
  // Quelle). Die früher pro Klick gesetzte stateIframeWindow.sketchfabUrl kam
  // beim Direktklick aus den Artefakt-Arrays mit Platzhalter-Urls → auf Mobile
  // falsche Links. Kein echter Link → "" → kein Button.
  const embed = getSketchfabUrl(snap.AnnotationId);
  if (!embed) return null;

  // Embed-URL (…/models/<id>/embed) → öffentliche Modellseite (…/models/<id>).
  const publicUrl = embed.replace(/\/embed\/?(\?.*)?$/i, "");

  const handleOpen = () => {
    window.open(publicUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <button className="openSketchfabButton" onPointerDown={handleOpen}>
      open sketchfab
    </button>
  );
}
